import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface CommentPopupProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => void;
}

const CommentPopup: React.FC<CommentPopupProps> = ({ open, onClose, onConfirm }) => {
  const [comment, setComment] = useState('');

  const handleConfirm = () => {
    onConfirm(comment);
    setComment('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ position: 'relative' }}>
        Add Comments
        <span className="mandatory"> *</span>
        <IconButton
          onClick={onClose}
          sx={{
            color: '#ff0000', position: 'absolute', right: 8, top: 8, '&:hover': {
              backgroundColor: 'rgba(255, 0, 0, 0.04)'
            }
          }}

        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <TextField
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          placeholder="Enter your comment..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} variant="contained" disabled={!comment.trim()}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommentPopup;